import type { App } from '@grafikr/components';
import header from 'layout/header';
import pagination from 'components/pagination';

import hasUrlParam from 'utils/loaders/has-url-param';
import intersectionLoader from 'utils/loaders/intersection';
import onElementInteraction from 'utils/loaders/on-element-interaction';
import onEvent from 'utils/loaders/on-event';

export default (app: App) => {
  app.add({
    // Layout
    header,

    // Components
    accordion: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-accordion" */ 'components/accordion'),
    ],
    'address-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-address-form" */ 'components/address-form'),
    ],
    announcements: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-announcements" */ 'components/announcements'),
    ],
    'cart-count': [
      onEvent,
      () => import(/* webpackChunkName: "component-cart-count" */ 'components/cart-count'),
    ],
    'cart-drawer': [
      [onEvent, onElementInteraction, hasUrlParam],
      () => import(/* webpackChunkName: "component-cart-drawer" */ 'components/cart-drawer'),
    ],
    'carousel-slider': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "component-carousel-slider" */ 'components/carousel-slider'),
    ],
    "contact-form": [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-copy" */ 'components/contact-form')
    ],
    copy: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-copy" */ 'components/copy'),
    ],
    drawer: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-drawer" */ 'components/drawer'),
    ],
    faq: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-faq" */ 'components/faq'),
    ],
    geolocator: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-geolocator" */ 'components/geolocator'),
    ],
    'lazy-content': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-lazy-content" */ 'components/lazy-content'),
    ],
    pagination,
    'product-item-recommendation': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-main" */ 'components/product-item-recommendation'),
    ],
    'quick-buy': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-quick-buy" */ 'components/quick-buy')
    ],
    'search-drawer': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-search-drawer" */ 'components/search-drawer'),
    ],
    subdrawer: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-subdrawer" */ 'components/subdrawer'),
    ],
    video: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-video" */ 'components/video'),
    ],

    // Pages
    product: [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-main" */ 'pages/product/main'),
    ],
    'product-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-form" */ 'pages/product/form'),
    ],
    'product-recommendations': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "product-recommendations" */ 'pages/product/recommendations'),
    ],
    'product-linked': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-linked" */ 'pages/product/linked'),
    ],
    'product-media': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-media" */ 'pages/product/media'),
    ],
  });
};
